import {DropzoneFile} from "Components/FileUpload/FileUpload";
import axios from "axios";
import {getAuth} from "Services/Security/AuthService";
import {http} from "Services/Http/HttpClient";

export const uploadActivityMedia = async (
    activityId: string,
    file: DropzoneFile,
    tag: string = ''
) => {
    let data = new FormData()
    data.append('file', file.file)

    if (tag) {
        data.append('tag', tag)
    }

    const fhttp = axios.create({
        baseURL: process.env.REACT_APP_API_URL,
        headers: {
            "Content-type": "multipart/form-data;",
            "Authorization": getAuth()
        }
    })

    return fhttp.post(`activity/${activityId}/medias`, data)
}

export const updateActivity = async (
    activityId: string,
    centerIds: string[],
    name: string,
    startDate: string,
    endDate: string,
    initPaymentDate: string,
    endPaymentDate: string,
    description: string,
    discounts: string[],
    services: string[],
    yearDays: any[],
    cancellationLocked: boolean,
    canSelectMultipleYearDays: boolean,
    inscriptionValidationType: number,
    category: number | null,
    paymentType: string | null,
    quarterlyPayment: boolean
) => {
    return http.patch(`activities/${activityId}`, {
        centers: centerIds,
        name: name,
        startDate: startDate,
        endDate: endDate,
        initPaymentDate: initPaymentDate,
        endPaymentDate: endPaymentDate,
        description: description,
        discounts: discounts,
        services: services,
        yearDays: yearDays,
        cancellationLocked: cancellationLocked,
        canSelectMultipleYearDays: canSelectMultipleYearDays,
        inscriptionValidationType: inscriptionValidationType,
        category: category,
        paymentType: paymentType,
        quarterlyPayment: quarterlyPayment
    })
}

export const deleteActivities = async(ids: string[]) : Promise<any> => {
    return http.delete('/activities/delete', {
        data: {
            ids: ids
        }
    })
}

export const duplicateActivity = async (activityId: string) : Promise<any> => {
    return http.post(`/activities/${activityId}/duplicate`)
}

export const createActivityPrivateInscription = async(userId: string, activityId: string) : Promise<any> => {
    return http.put(`/activity/${activityId}/${userId}`);
}

export const removeActivityMedia = async (activityMediaId: string) : Promise<any> => {
    return http.delete(`/activity/media/${activityMediaId}`)
}